import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import orderStore from "../stores/OrderStore";
import { getDateFromDateString } from "../utils/helperFunctions";
import { useReactToPrint } from "react-to-print";
import { Button } from "antd";

export const InvoiceScreen = () => {
  const { state } = useLocation();
  const {
    priceList,
    washAndFoldQuantity,
    washAndIronQuantity,
    premiumWashAndIronQuantity,
    quantities,
    orderId,
    discount,
  } = state;
  const [order, setOrder] = useState(null);
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const getOrderByIdFromStore = (orderId) => {
    return orderStore.orders.find((order) => order.id === orderId);
  };

  useEffect(() => {
    setOrder(getOrderByIdFromStore(orderId));
  }, [orderId]);

  const selectedItems = [];

  const getDiscountedPrice = (item) => {
    const quantity = Number(quantities[item.cloth_name]) || 0;
    const defaultPrice =
      Number(item.discounted_price) || Number(item.price) || 0;

    if (
      !Array.isArray(item.quantity_pricing) ||
      item.quantity_pricing.length === 0
    ) {
      return defaultPrice;
    }

    const matchedTier = [...item.quantity_pricing]
      .sort((a, b) => Number(a.above_quantity) - Number(b.above_quantity))
      .reduce((selectedTier, tier) => {
        if (quantity >= Number(tier.above_quantity)) {
          return tier;
        }
        return selectedTier;
      }, null);

    return matchedTier ? Number(matchedTier.price) : defaultPrice;
  };

  priceList.forEach((item) => {
    if (item.cloth_name === "wash_and_fold" && washAndFoldQuantity > 0) {
      selectedItems.push({
        cloth_name: "wash_and_fold",
        display_name: `Wash and Fold - ${washAndFoldQuantity} pcs`,
        price: item.price,
        discounted_price: getDiscountedPrice(item),
      });
    } else if (item.cloth_name === "wash_and_iron" && washAndIronQuantity > 0) {
      selectedItems.push({
        cloth_name: "wash_and_iron",
        display_name: `Wash and Iron - ${washAndIronQuantity} pcs`,
        price: item.price,
        discounted_price: getDiscountedPrice(item),
      });
    } else if (
      item.cloth_name === "premium_wash_and_iron" &&
      premiumWashAndIronQuantity > 0
    ) {
      selectedItems.push({
        cloth_name: "premium_wash_and_iron",
        display_name: `Premium Wash and Iron - ${premiumWashAndIronQuantity} pcs`,
        price: item.price,
        discounted_price: getDiscountedPrice(item),
      });
    } else if (quantities[item.cloth_name] > 0) {
      selectedItems.push({
        ...item,
        discounted_price: getDiscountedPrice(item),
        quantity: quantities[item.cloth_name],
      });
    }
  });

  const calculateTotal = () => {
    let total = 0;
    selectedItems.forEach((item) => {
      const quantity = quantities[item.cloth_name];
      const price = getDiscountedPrice(item);
      total += price * quantity;
    });
    return total;
  };

  return order ? (
    <>
      <div className="text-center">
        <Button
          className="mt-10"
          type="primary"
          onClick={() => {
            reactToPrintFn();
            if (navigator.userAgent) {
              if (navigator.userAgent.includes("wv")) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    name: order.full_name,
                    phone_number: order.phone_number,
                    id: order.id,
                    selectedItems: selectedItems,
                    quantities: quantities,
                  }),
                );
              }
            }
          }}
        >
          Print
        </Button>
      </div>
      <div className="pr-2 pl-2" ref={contentRef}>
        <div className="flex flex-col text-center items-center mt-2">
          <p className="font-bold text-2xl">DoorWash</p>
          <p className="mt-2 text-xl">Nalanda Colony, Khajpura, Patna-14</p>
          <p className="text-xl">+91-9942005010</p>
          <p className="text-xl">CIN: U96010BR2025PTC074030</p>
          <p className="text-xl">GSTIN: 10AALCD4632P1ZI</p>
        </div>
        <hr className="mt-3" />
        <div className="mt-3 flex flex-row text-sm justify-between">
          <div className="text-center flex-col flex-1 text-xl">
            <div>
              <p>Name: {order.full_name}</p>
            </div>
            <div>
              <p>Phone Number: {order.phone_number}</p>
            </div>
            <div>
              <p>Order: {orderId}</p>
            </div>
            <div>
              <p>
                Date:{" "}
                {order?.order_pickup
                  ? getDateFromDateString(order?.order_pickup.created_at)
                  : getDateFromDateString(order?.created_at)}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-3 text-xl">
          <table className="w-full table-auto border-collapse mt-4">
            <thead>
              <tr className="text-left border-b">
                <th className="px-2 py-1">Item</th>
                <th className="px-2 py-1 text-right">Qty</th>
                <th className="px-2 py-1 text-right">Price</th>
                <th className="px-2 py-1 text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {selectedItems.map((item) => {
                const quantity = quantities[item.cloth_name];
                const price = item.discounted_price;
                const total = price * quantity;

                return (
                  <tr key={item.cloth_name} className="border-b">
                    <td className="px-2 py-1">{item.display_name}</td>
                    <td className="px-2 py-1 text-right">
                      {item.cloth_name === "wash_and_fold" ||
                      item.cloth_name === "wash_and_iron" ||
                      item.cloth_name === "premium_wash_and_iron"
                        ? `${quantities[item.cloth_name]}kg`
                        : `${quantities[item.cloth_name]}`}
                    </td>
                    <td className="px-2 py-1 text-right">{price}</td>
                    <td className="px-2 py-1 text-right">{total}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {discount ? (
          <>
            <div className="flex justify-between text-xl">
              <strong>Total</strong>
              <strong>{calculateTotal()}</strong>
            </div>
            <div className="flex justify-between text-xl">
              <strong>Discount</strong>
              <strong>{discount}</strong>
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="flex justify-between text-xl">
          <strong>Net Payable</strong>
          <strong>{calculateTotal() - discount}</strong>
        </div>
        <div className="mt-5">
          <p className="text-lg text-center">
            This is for reference for number of clothes given and not the final
            invoice.
          </p>
        </div>
      </div>
    </>
  ) : (
    <p>Loading</p>
  );
};
